import { Palette } from "lucide-react";

export const COLOR_PALETTE = [
  "#3b82f6", // Blue
  "#ef4444", // Red
  "#10b981", // Green
  "#f59e0b", // Yellow
  "#8b5cf6", // Purple
  "#ec4899", // Pink
  "#06b6d4", // Cyan
  "#84cc16", // Lime
  "#f97316", // Orange
  "#6366f1", // Indigo
  "#14b8a6", // Teal
  "#eab308", // Amber
];

interface ColorPaletteProps {
  selectedColor: string;
  onColorSelect: (color: string) => void;
}

export const ColorPalette = ({ selectedColor, onColorSelect }: ColorPaletteProps) => {
  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2">
        <Palette className="h-4 w-4" />
        <span className="text-sm text-muted-foreground">Select color:</span>
      </div>
      <div className="grid grid-cols-6 gap-2">
        {COLOR_PALETTE.map((color) => (
          <button
            key={color}
            type="button"
            onClick={() => onColorSelect(color)}
            className={`w-8 h-8 rounded-md border-2 transition-all ${
              selectedColor === color 
                ? 'border-foreground scale-110' 
                : 'border-transparent hover:border-muted-foreground'
            }`}
            style={{ backgroundColor: color }}
          />
        ))}
      </div>
    </div>
  );
};